import { useFindAllHardwareCategoriesQuery } from "../api/api-hooks";

export const useHardwareCategoryMap = () => {
  const { data: categories } = useFindAllHardwareCategoriesQuery({});
  const map = new Map<number, string>();
  if (categories === undefined) return map;
  for (const category of categories) {
    map.set(category.id, category.categoryName);
  }
  return map;
};
